import BaseMystery from '../BaseMystery'

const FifthSorrowfulMystery = () => {
	const imagesList = [
		"https://www.wga.hu/art/a/altichie/2/2crucif1.jpg",
		"https://www.wga.hu/art/a/altichie/1/2christ4.jpg",
		"https://www.wga.hu/art/a/altdorfe/2/11crucif.jpg",
		"https://www.wga.hu/art/a/alesso/crucifix.jpg",
		"https://www.wga.hu/art/a/andrea/firenze/various/x_crucif.jpg",
		"https://www.wga.hu/art/a/andrea/castagno/3_1450s/02crucif.jpg",
		"https://www.wga.hu/art/a/andrea/castagno/3_1450s/07cruci1.jpg",
		"https://www.wga.hu/art/a/andrea/castagno/1_1440s/01crucif.jpg",
		"https://www.wga.hu/art/a/andrea/bartolo/crucifix.jpg",
		"https://www.wga.hu/art/a/andrea/bartolo/predell1.jpg",
		"https://www.wga.hu/art/a/angelico/13/01crucif.jpg",
		"https://www.wga.hu/art/a/angelico/09/corridor/crucifi.jpg",
		"https://www.wga.hu/art/a/angelico/09/cells/37_cruci.jpg",
		"https://www.wga.hu/art/a/angelico/14/4fiesole.jpg",
		"https://www.wga.hu/art/a/angelico/09/cells/38_cruci.jpg",
		"https://www.wga.hu/art/a/angelico/13/00crucif.jpg",
		"https://www.wga.hu/art/a/angelico/09/cells/25_cruci.jpg",
		"https://www.wga.hu/art/a/antonell/crucifix.jpg",
		"https://www.wga.hu/art/a/antonell/crucifiy.jpg",
		"https://www.wga.hu/art/a/antonio/firenze/crucifix.jpg",
		"https://www.wga.hu/art/b/baegert/crucifix.jpg",
		"https://www.wga.hu/art/b/baldung/2/031cruci.jpg",
		"https://www.wga.hu/art/b/barnaba/crucifix.jpg",
		"https://www.wga.hu/art/b/bellini/giovanni/1500-09/171cruci.jpg",
		"https://www.wga.hu/art/b/bellini/jacopo/crucifix.jpg",
		"https://www.wga.hu/art/b/bermejo/crucifix.jpg",
		"https://www.wga.hu/art/b/botticel/91late/09crucif.jpg",
		"https://www.wga.hu/art/b/bramanti/crucifix.jpg",
		"https://www.wga.hu/art/b/breu/elder/crucifix.jpg",
		"https://www.wga.hu/art/b/bruegel/pieter_y/2/crucifix.jpg",
		"https://www.wga.hu/art/c/campana/crucifix.jpg",
		"https://www.wga.hu/art/c/cano/crucifix.jpg",
		"https://www.wga.hu/art/c/carpioni/crucifix.jpg",
		"https://www.wga.hu/art/c/carracci/annibale/1/crucifix.jpg",
		"https://www.wga.hu/art/c/caullery/crucifix.jpg",
		"https://www.wga.hu/art/c/cavallin/painting/crucifix.jpg",
		"https://www.wga.hu/art/c/champaig/philippe/crucifix.jpg",
		"https://www.wga.hu/art/c/conti/crucifix.jpg",
		"https://www.wga.hu/art/c/corneliz/crucifi.jpg",
		"https://www.wga.hu/art/c/corneliz/crucifix.jpg",
		"https://www.wga.hu/art/c/cranach/lucas_e/04/11religj.jpg",
		"https://www.wga.hu/art/d/david/2/crucifix.jpg",
		"https://www.wga.hu/art/d/david/1/crucifiz.jpg",
		"https://www.wga.hu/art/d/diepenbe/crucifix.jpg",
		"https://www.wga.hu/art/d/dyck_van/3other/crucifix.jpg",
		"https://www.wga.hu/art/f/ferrari/defenden/crucifix.jpg",
		"https://www.wga.hu/art/f/ferrari/gaudenzi/various/crucifix.jpg",
		"https://www.wga.hu/art/f/ferrari/gaudenzi/vercelli/1maddal1.jpg",
		"https://www.wga.hu/art/g/gaddi/taddeo/other/1crucifi.jpg",
		"https://www.wga.hu/art/g/gherardu/crucifix.jpg",
		"https://www.wga.hu/art/g/giotto/assisi/lower/ceiling/09christ.jpg",
		"https://www.wga.hu/art/g/giusto/padua/5east.jpg",
		"https://www.wga.hu/art/g/gonzvela/antonio/crucifix.jpg",
		"https://www.wga.hu/art/g/grunewal/1/02crucif.jpg",
		"https://www.wga.hu/art/s/savoldo/crucifix.jpg",
	];

	const scriptureQuote = "When the centurion who stood facing him saw how he breathed his last he said, \"Truly this man was the Son of God!\"";
	const scriptureCitation = "Mark 15:39 (NABRE)";
	const citationLink = "https://www.biblegateway.com/passage/?search=Mark%2015%3A39%2C%20John%2019%3A23-37&version=NABRE";

	return (
		<BaseMystery titleText="The Crucifixion"
				imagesList={imagesList}
				scriptureQuote={scriptureQuote}
				scriptureCitation={scriptureCitation}
				citationLink={citationLink}
				rightHanded={false} />
	);
};

export default FifthSorrowfulMystery;